import React, { SVGProps } from 'react';

const AddConnectionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.41406 8.13477H11.8648V11.5855" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11.8697 8.12947L5.74984 14.2493C5.32043 14.6788 4.62345 14.6788 4.19405 14.2493C3.11239 13.1677 2.50325 11.7006 2.5 10.1708C2.5 9.17046 2.69356 8.17014 3.07824 7.22918C3.45722 6.30286 4.02082 5.4351 4.7731 4.68364C6.12232 3.33442 7.98634 2.5 10.0447 2.5C10.5427 2.5 11.0293 2.54884 11.5 2.64199M7.67241 17.0137C8.44096 17.2723 9.24203 17.4105 10.0447 17.4105C12.1039 17.4105 13.9671 16.5761 15.3164 15.2269C16.6656 13.8777 17.5 12.0137 17.5 9.95527C17.5 9.45721 17.4512 8.97062 17.3581 8.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14.125 4.37695H17.125" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.6211 5.875V2.875" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default AddConnectionIcon;
